<template>
  <pui-flex class="pui-file-notification" direction="column" flex="1">
    <!-- ANY IN PROGRESS -->
    <template v-if="state === FileTaskStatus.IN_PROGRESS">
      <pui-flex class="file-notification-title">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-clock-outline"></span>
          {{ $t('dam.files.update.notification.title.in_progress') }}
        </div>
      </pui-flex>
      <div class="file-notification-content">
        {{ $t('dam.files.update.notification.message.in_progress') }}
        <pui-common-progress-linear hideMessage />
      </div>
    </template>

    <!-- BOTH DONE -->
    <template v-else-if="state === FileTaskStatus.DONE_SUCCESS">
      <pui-flex class="file-notification-title notification-success">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-check-circle-outline"></span>
          {{ $t('dam.files.update.notification.title.success') }}
        </div>
        <div class="notif-title-secondary">
          <pui-button
            @click.stop="dismissNotification"
            picto="mdi-close"
            flat
            variant="secondary"
          />
        </div>
      </pui-flex>
      <div class="file-notification-content">
        <div>
          {{ $t('dam.files.update.notification.message.success') }}
        </div>
      </div>
    </template>

    <!-- ANY ERROR -->
    <template v-else-if="state === FileTaskStatus.ERROR">
      <pui-flex class="file-notification-title notification-error">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-alert-circle-outline"></span>
          {{ $t('dam.files.update.notification.title.error') }}
        </div>
        <div class="notif-title-secondary">
          <pui-button
            @click.stop="dismissNotification"
            picto="mdi-close"
            flat
            variant="secondary"
          />
        </div>
      </pui-flex>
      <div class="file-notification-content">
        <div>
          {{ $t('dam.files.update.notification.message.error') }}
        </div>
      </div>
    </template>
  </pui-flex>
</template>

<script>
import services from '../../../../core/services';
import notificationItemMixin from '../../../../platform/components/notifications/notificationItemMixin';
import { FileTaskStatus } from '../../constants/file';

export default {
  name: 'pui-file-update-notification',
  mixins: [notificationItemMixin],
  data() {
    return {
      FileTaskStatus,
    };
  },
  computed: {
    /**
     * @returns {string} merged state of the two operations
     */
    state() {
      return this.data.state();
    },
  },
  methods: {
    // NOTIF ACTIONS
    /**
     * Removes this notification
     *
     * @returns {void}
     */
    dismissNotification() {
      services.getService('notifications').removeNotification(this.id);
    },
  },
};
</script>
